/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Digest_Turned_OffInputs */

const en_digest_turned_off = /** @type {(inputs: Digest_Turned_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No more Monday digest. Turn it on again from this menu.`)
};

/**
* | output |
* | --- |
* | "No more Monday digest. Turn it on again from this menu." |
*
* @param {Digest_Turned_OffInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const digest_turned_off = /** @type {((inputs?: Digest_Turned_OffInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Digest_Turned_OffInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_digest_turned_off(inputs)
});